import '../App.css';
import '../css/BaseElements.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/BaseElementsCSS/BaseElementsDesktop.css';
function Level ({levelInfo}){

    return <div className='baseElementsSquare baseElementsTobBarElementsText'>
        <div className='star center'>{levelInfo}</div></div>
}
export default Level;